import axios from "axios";
import { ReplaceProps } from "@syla/shared/types/helpers/ReplaceProps";

import { User, TaxSettings } from "../../types/user/user";

export const updateUser = async (newProps: UpdateUser): Promise<User> => {
  const { data } = await axios.patch("/users", newProps);
  return data;
};

export type UpdateTaxSettings = Partial<TaxSettings>;

export type UpdateUser = Partial<
  ReplaceProps<
    User,
    "taxSettings",
    { taxSettings: UpdateTaxSettings; password: string }
  >
>;
